import React, { useState, useEffect } from 'react';
import PropTypes from 'prop-types';
import { Typography } from '@mui/material';
import { getFirestore, collection, query, where, getDocs } from 'firebase/firestore';

const RemainingAnnualLeaves = ({ userId }) => {
  const [remainingAnnualLeaves, setRemainingAnnualLeaves] = useState(null);
  const [loading, setLoading] = useState(true);

  const db = getFirestore();

  useEffect(() => {
    const fetchRemainingAnnualLeaves = async () => {
      try {
        if (!userId) {
          console.error("User ID is not provided");
          setRemainingAnnualLeaves('User ID missing');
          setLoading(false);
          return;
        }

        const leaveRef = collection(db, 'employeeAnnualLeave');
        const q = query(leaveRef, where('employeeId', '==', userId));
        const querySnapshot = await getDocs(q);

        if (!querySnapshot.empty) {
          const leaveData = querySnapshot.docs[0].data();
          setRemainingAnnualLeaves(leaveData.remainingAnnualLeaves || 'No data found');
        } else {
          setRemainingAnnualLeaves('No records found');
        }
      } catch (error) {
        console.error("Error fetching annual leaves:", error);
        setRemainingAnnualLeaves('Error loading data');
      } finally {
        setLoading(false);
      }
    };

    fetchRemainingAnnualLeaves();
  }, [userId, db]);

  return (
    <Typography variant="h4">
      {loading ? 'Loading...' : remainingAnnualLeaves} Days
    </Typography>
  );
};

RemainingAnnualLeaves.propTypes = {
  userId: PropTypes.string.isRequired,
};

export default RemainingAnnualLeaves;
